import { render, staticRenderFns } from "./ActivitiesConsole.vue?vue&type=template&id=23b20a00&scoped=true&"
import script from "./ActivitiesConsole.vue?vue&type=script&lang=js&"
export * from "./ActivitiesConsole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b20a00",
  null
  
)

export default component.exports